// The two social preview cards, and the alt text for each.
//
// Four places need these and none of them may disagree: scripts/prerender.mjs
// writes them into every static route, netlify/edge-functions/wallet-meta.js
// sets them on wallet and transaction URLs at request time,
// public/index.html carries the generic one as the static default for anything
// neither touches, and Seo.js sets them again in the browser once the bundle
// runs. A second copy of the alt text would drift, which is the same reason
// routeMeta.js exists.
//
// Why two cards. The home page shows a screenshot of itself, which is honest
// there and demonstrates the product. Every other page shows the generic one,
// because the screenshot was previously site-wide and meant sharing /mempool/
// previewed a live transaction feed that page does not have.
//
// Splitting them also contains the screenshot's staleness: it goes out of date
// whenever the top of Bitcoin Live changes, and once sat for ten days showing a
// nav without Mempool on the card for every page on the site. Now it can only
// ever be wrong about the one page it is a picture of.
//
// Imports nothing, like the other leaf modules the prerender script and the
// edge function share.

export const OG_CARDS = {
  home: {
    path: "/images/og-bitcoin-live.png",
    alt: "The d2index Bitcoin Live page: the Bitcoin price and its 24 hour move, a tape of Bitcoin transfers as they are broadcast, and a whale watch panel listing the largest recent transfers with their size in BTC and dollars, one marked as moving onto Binance.",
  },
  generic: {
    path: "/images/og-card.png",
    alt: "The d2index card: the site name over a tape of Bitcoin transfers, and three lines reading live Bitcoin transactions and each block as it lands, wallet and transaction lookup with the other side named, and exchange, mining pool and OFAC-sanctioned address lists.",
  },
};

// The image and its alt text travel together on purpose. The alt describes one
// specific picture, so a caller that swapped the image and kept the alt would be
// telling a screen reader about a card it is not showing - which is exactly what
// the site did before this file, with one alt describing the screenshot on every
// page whatever image they carried.
export const cardTags = (siteUrl, card) => ({
  image: `${siteUrl}${card.path}`,
  imageAlt: card.alt,
});

export const cardForRoute = (route) =>
  route === "/" ? OG_CARDS.home : OG_CARDS.generic;
